import { BASE_URL } from "../utils/axiosConfig";

export async function getArticle(name, lang = "en") {
	try {
		const response = await fetch(
			`${BASE_URL}/article?name=${name}&lang=${lang}`,
		);

		const { name: articleName, content, error } = await response.json();

		return {
			name: articleName,
			content,
			error: error,
		};
	} catch (error) {
		return {
			name: null,
			content: null,
			error:
				error instanceof Error ? error.message : "An unknown error occurred",
		};
	}
}
